import axios from 'axios';
import {
    getRequest,
    getSuccess,
    getFailed,
    getError
} from './noticeSlice';

export const getAllNotices = (id, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${process.env.REACT_APP_BASE_URL}/${address}List/${id}`);
        
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else if (Array.isArray(result.data)) {
            dispatch(getSuccess(result.data));
        } else {
            dispatch(getFailed('Invalid response format'));
        }
    } catch (error) {
        if (error.response) {
            
            // Extract serializable error message
            const errorMessage = error.response.data?.message 
                || error.response.data?.error 
                || `Server error (${error.response.status})`;
            dispatch(getError(errorMessage));
        } else if (error.request) {
            // Network error (no response received)
            dispatch(getError('Unable to connect to server. Please check your connection.'));
        } else {
            // Something else went wrong
            dispatch(getError(error.message || 'An unknown error occurred'));
        }
    }
}

// Force refresh notices - useful after adding a new notice
export const refreshNotices = (id, address) => async (dispatch) => {
    dispatch(getSuccess([])); // Clear current notices
    dispatch(getAllNotices(id, address)); // Fetch fresh data
}

